import * as Sentry from "@sentry/nextjs"

import useToast from "@hooks/useToast"
import { ParticipationDetailsFormAttributes } from "@modules/tenants/OrdersPage/Components/AddOrderModal/ParticipationDetailsForm/ParticipationDetailsForm"
import { UpdatePerBookingFieldsOfOrderRequestType } from "@mono/essentials/entities/cart/types"
import { useUpdatePerBookingFieldsOfOrderMutation } from "@mono/essentials/entities/order/hooks"
import { GetOrderDetailsResponseType } from "@mono/essentials/types/OrderTypes"

export const useHandleUpdateBookingDetailsOfOrderItem = () => {
  const { showToast } = useToast()
  const { mutateAsync: updatePerBookingFieldsOfOrderMutation } =
    useUpdatePerBookingFieldsOfOrderMutation()

  const handleUpdateBookingDetailsOfOrderItem = async ({
    formValues,
    orderItemId,
    orderData,
    onSuccess,
    onError,
  }: {
    formValues: ParticipationDetailsFormAttributes
    orderItemId: string
    orderData: GetOrderDetailsResponseType
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
  }) => {
    try {
      if (formValues?.perBookingFieldsDetails?.length && orderData?.id && orderItemId) {
        const payload: UpdatePerBookingFieldsOfOrderRequestType = []
        Object.keys(formValues?.perBookingFieldsDetails?.[0] ?? {})
          .filter(
            (fieldKey) => fieldKey.includes("_id") && !fieldKey.includes("_order_item_field_id")
          )
          .forEach((fieldIdKey) => {
            payload.push({
              id: formValues.perBookingFieldsDetails?.[0][
                `${fieldIdKey?.split("_id")?.[0]}_order_item_field_id`
              ] as string,
              field_id: formValues.perBookingFieldsDetails?.[0][
                `${fieldIdKey?.split("_id")?.[0]}_order_item_field_id`
              ]
                ? undefined
                : ((formValues.perBookingFieldsDetails?.[0][fieldIdKey] ?? "") as string),
              value: formValues.perBookingFieldsDetails?.[0][fieldIdKey?.split("_id")?.[0]] ?? "",
              order_item_id: orderItemId,
            })
          })
        await updatePerBookingFieldsOfOrderMutation({
          orderId: orderData?.id,
          body: payload,
        })
        await onSuccess?.()
      } else {
        showToast({
          heading: "Unable to update the booking details! please try again later.",
          type: "danger",
        })
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleUpdateBookingDetailsOfOrderItem }
}
